/** Return a new adjacent order, or null when the page cannot move. */
export function movePageId(ids, pageId, direction) {
  if (!Array.isArray(ids) || (direction !== -1 && direction !== 1)) return null;
  const from = ids.indexOf(pageId);
  const to = from + direction;
  if (from < 0 || to < 0 || to >= ids.length) return null;
  const ordered = [...ids];
  const [moved] = ordered.splice(from, 1);
  ordered.splice(to, 0, moved);
  return ordered;
}
